/* PDP Hero — Flow Nutrition */

(function () {
  'use strict';

  const wrap = document.querySelector('.pdph-wrap');
  if (!wrap) return;

  const dataEl = document.getElementById('pdph-product-data');
  if (!dataEl) return;
  const DATA = JSON.parse(dataEl.textContent);

  // ── Helpers ──────────────────────────────────
  // Finální částka: u CZK vždy celé koruny (haléře se u nás nepoužívají),
  // u ostatních měn beze změny (desetiny jen když nejsou nulové).
  function fmt(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CZK';
    var digits = currency === 'CZK' ? 0 : (cents % 100 !== 0 ? 2 : 0);
    var amount = currency === 'CZK' ? Math.round(cents / 100) : cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'cs-CZ', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      }).format(amount);
    } catch (e) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    }
  }

  // Cena za jednotku (tob./dávka) z ceny v centech – 1:1 s výpočtem v Liquidu.
  function perUnit(cents, caps, suffix) {
    if (caps <= 0 || !suffix) return null;
    var raw = Math.floor(cents * 10 / caps);
    var pc = (raw % 10 >= 5) ? Math.floor(raw / 10) + 1 : Math.floor(raw / 10);
    return fmtUnit(pc) + suffix;
  }

  // Cena za jednotku (tob./dávka): vždy s 2 desetinnými místy, u všech měn.
  function fmtUnit(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CZK';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'cs-CZ', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (e) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    }
  }

  // ── Sjednocení formátu ceny/tob. u karet balení ──────────────────
  // Liquidový `money` filtr může dle nastavení obchodu desetiny vynechávat;
  // přeformátujeme podle data-price/data-caps, ať je to vždy s 2 desetinami.
  wrap.querySelectorAll('.pdph-pack-card').forEach(function (card) {
    var sup = card.querySelector('.pdph-sup');
    if (!sup) return;
    var price = parseInt(card.getAttribute('data-price'), 10);
    var caps = parseInt(card.getAttribute('data-caps'), 10);
    var pu = perUnit(price, caps, DATA.unitSuffix);
    if (pu) sup.textContent = pu;
  });

  function calcSubPrice(basePrice, plan) {
    if (!plan) return basePrice;
    if (plan.discountType === 'percentage') return Math.round(basePrice * (1 - plan.discountValue / 100));
    if (plan.discountType === 'fixed_amount') return Math.max(0, basePrice - plan.discountValue);
    if (plan.discountType === 'price') return plan.discountValue;
    return basePrice;
  }

  // ── Judge.me hvězdičky: přesuň badge ze slotu pod hlavní nadpis ──
  // Judge.me plní hvězdičkami app blok, který se renderuje do .pdph-subscription-slot
  // (pod „Frekvence"). Přesuneme ho pod nadpis do .pdph-rate. Recharge widgetu se to netýká.
  (function () {
    const rate = wrap.querySelector('.pdph-rate');
    const slot = wrap.querySelector('.pdph-subscription-slot');
    if (!rate || !slot) return;
    function move() {
      const badge = slot.querySelector('.jdgm-widget, .jdgm-preview-badge');
      if (badge) { rate.textContent = ''; rate.appendChild(badge); }
    }
    move();
    new MutationObserver(move).observe(slot, { childList: true, subtree: true });
  })();

  // ── State ────────────────────────────────────
  let state = {
    mode: 'once',
    planId: DATA.sellingPlans.length ? DATA.sellingPlans[0].id : null,
  };

  // ── Elementy ─────────────────────────────────
  const freqbox    = wrap.querySelector('#pdph-freqbox');
  const onceRow    = freqbox && freqbox.querySelector('[data-mode="once"]');
  const subRow     = freqbox && freqbox.querySelector('[data-mode="sub"]');
  const freqSel    = wrap.querySelector('#pdph-freqsel');
  const priceNow   = wrap.querySelector('#pdph-price-now');
  const pricePct   = wrap.querySelector('#pdph-price-pct');
  const discRow    = wrap.querySelector('#pdph-discount-row');
  const priceWas   = wrap.querySelector('#pdph-price-was');
  const priceSaved = wrap.querySelector('#pdph-price-saved');
  const pricePu    = wrap.querySelector('#pdph-price-pu');
  const priceVat   = wrap.querySelector('#pdph-price-vat');
  const oncePrice  = wrap.querySelector('#pdph-once-price');
  const subPrice   = wrap.querySelector('#pdph-sub-price');
  const spInput    = wrap.querySelector('#pdph-selling-plan');

  // ── Přepočet ceny ─────────────────────────────
  function updatePrice() {
    const base = DATA.price;
    const plan = DATA.sellingPlans.find(p => p.id === state.planId);
    const subAmt = DATA.hasSubscription ? calcSubPrice(base, plan) : base;

    if (oncePrice) oncePrice.textContent = fmt(base);
    if (subPrice && DATA.hasSubscription) {
      const pct = plan && plan.discountType === 'percentage' ? plan.discountValue : 0;
      subPrice.innerHTML = fmt(subAmt) + (pct ? ' <span class="pdph-pct">-' + pct + '&nbsp;%</span>' : '');
    }

    if (state.mode === 'once') {
      if (priceNow)   priceNow.textContent = fmt(base);
      if (pricePct)   { pricePct.style.display = DATA.packDiscountPct ? '' : 'none'; pricePct.innerHTML = DATA.packDiscountPct || ''; }
      if (discRow)    discRow.style.display = 'none';
      const oncePu = perUnit(base, DATA.capsuleCount || 0, DATA.unitSuffix) || DATA.pricePerUnit;
      if (pricePu)    { pricePu.style.display = oncePu ? '' : 'none'; pricePu.textContent = oncePu || ''; }
      if (priceVat)   priceVat.textContent = (DATA.durationText ? ' · vydrží ' + DATA.durationText : '');
      if (spInput)    { spInput.value = ''; spInput.disabled = true; }
    } else {
      const pct = plan && plan.discountType === 'percentage' ? plan.discountValue : 0;
      const saved = base - subAmt;
      if (priceNow)   priceNow.textContent = fmt(subAmt);
      if (pricePct)   { pricePct.style.display = pct ? '' : 'none'; pricePct.innerHTML = pct ? '-' + pct + '&nbsp;%' : ''; }
      if (discRow)    discRow.style.display = saved > 0 ? 'flex' : 'none';
      if (priceWas)   priceWas.textContent = fmt(base);
      if (priceSaved) priceSaved.textContent = 'ušetříte ' + fmt(saved);
      if (pricePu)    pricePu.style.display = 'none';
      if (priceVat)   priceVat.textContent = ' · opakované doručení · zrušíte kdykoli';
      if (spInput && state.planId) { spInput.value = state.planId; spInput.disabled = false; }
    }
  }

  // ── Galerie ──────────────────────────────────
  const mainImg = wrap.querySelector('#pdph-main-img');
  wrap.querySelectorAll('.pdph-thumb').forEach(btn => {
    btn.addEventListener('click', () => {
      wrap.querySelectorAll('.pdph-thumb').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (mainImg) {
        // DŮLEŽITÉ: srcset má přednost před src — musíme ho odstranit,
        // jinak prohlížeč dál zobrazuje původní obrázek ze srcsetu.
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.style.opacity = '0';
        mainImg.onload = () => { mainImg.style.opacity = '1'; };
        mainImg.src = btn.dataset.src;
        mainImg.alt = btn.dataset.alt || '';
        if (mainImg.complete) mainImg.style.opacity = '1';
      }
    });
  });

  // ── Lightbox galerie (zvětšení + swipe) ────────
  const lightbox = document.getElementById('pdph-lightbox');
  if (lightbox) {
    const lbTrack = lightbox.querySelector('.pdph-lb-track');
    const lbClose = lightbox.querySelector('.pdph-lb-close');
    function openLb(index) {
      lightbox.showModal();
      requestAnimationFrame(() => {
        lbTrack.scrollLeft = (index || 0) * lbTrack.clientWidth;
      });
    }
    // otevření z desktop hlavní fotky
    if (mainImg) mainImg.addEventListener('click', () => {
      const active = wrap.querySelector('.pdph-thumb.is-active');
      const thumbs = [...wrap.querySelectorAll('.pdph-thumb')];
      openLb(active ? thumbs.indexOf(active) : 0);
    });
    // otevření z mobilní galerie
    wrap.querySelectorAll('.pdph-mgallery-slide img').forEach((img, i) => {
      img.addEventListener('click', () => openLb(i));
    });
    // šipky — s přetočením (za poslední → první, před první → poslední)
    lightbox.querySelectorAll('.pdph-lb-nav').forEach(btn => {
      btn.addEventListener('click', () => {
        const n = lightbox.querySelectorAll('.pdph-lb-slide').length;
        if (!n) return;
        const dir = parseInt(btn.dataset.dir, 10);
        let idx = Math.round(lbTrack.scrollLeft / lbTrack.clientWidth) + dir;
        if (idx < 0) idx = n - 1;
        else if (idx >= n) idx = 0;
        lbTrack.scrollTo({ left: idx * lbTrack.clientWidth, behavior: 'smooth' });
      });
    });
    if (lbClose) lbClose.addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', e => {
      if (e.target === lightbox || e.target.classList.contains('pdph-lb-track') || e.target.classList.contains('pdph-lb-slide')) lightbox.close();
    });
  }

  // ── Mobilní galerie — aktivní tečka podle posunu ────────
  const mTrack = wrap.querySelector('.pdph-mgallery-track');
  const mDots = wrap.querySelectorAll('.pdph-mdot');
  if (mTrack && mDots.length) {
    let mRaf;
    mTrack.addEventListener('scroll', () => {
      if (mRaf) return;
      mRaf = requestAnimationFrame(() => {
        mRaf = null;
        const idx = Math.round(mTrack.scrollLeft / mTrack.clientWidth);
        mDots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      });
    }, { passive: true });
  }

  // ── Frekvence — vlastní UI řídí Recharge přes selling_plan ────────
  const packSeg = wrap.querySelector('.pdph-seg');

  function setFreqMode(mode) {
    state.mode = mode;
    if (packSeg) packSeg.classList.toggle('is-sub', mode === 'sub');
    // Pack karty — červený rámeček jen při jednorázovém nákupu
    freqbox && freqbox.querySelectorAll('.pdph-subrow').forEach(r => {
      const active = r.dataset.mode === mode;
      r.classList.toggle('is-active', active);
      r.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    updatePrice();
  }

  if (freqbox) {
    freqbox.querySelectorAll('.pdph-subrow').forEach(row => {
      row.addEventListener('click', () => setFreqMode(row.dataset.mode));
    });
  }

  // Změna frekvence automaticky přepne na předplatné
  if (freqSel) {
    freqSel.addEventListener('change', () => {
      state.planId = parseInt(freqSel.value, 10);
      setFreqMode('sub');
    });
  }

  // ── Stepper ──────────────────────────────────
  const qtyInput = wrap.querySelector('#pdph-qty');
  wrap.querySelectorAll('.pdph-step-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) + parseInt(btn.dataset.step, 10));
    });
  });

  // ── Přidání do košíku (AJAX) → otevře theme cart drawer ────────
  const buyForm = wrap.querySelector('.pdph-form');
  let adding = false;
  async function pdphAddToCart(triggerBtn) {
    if (adding || !buyForm) return;
    const idEl = buyForm.querySelector('[name="id"]');
    if (!idEl) return;
    adding = true;
    if (triggerBtn) triggerBtn.classList.add('btn--loading');
    const qtyEl = buyForm.querySelector('[name="quantity"]');
    const qty = qtyEl ? Math.max(1, parseInt(qtyEl.value || '1', 10)) : 1;
    const item = { id: idEl.value, quantity: qty };
    const sp = buyForm.querySelector('[name="selling_plan"]');
    if (sp && !sp.disabled && sp.value) item.selling_plan = sp.value;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      if (res.ok) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        try {
          const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
          if (window.FoxTheme && FoxTheme.pubsub) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          }
        } catch (e) {}
      }
    } catch (e) {} finally {
      adding = false;
      if (triggerBtn) triggerBtn.classList.remove('btn--loading');
    }
  }
  if (buyForm) {
    buyForm.addEventListener('submit', (e) => {
      e.preventDefault();
      pdphAddToCart(buyForm.querySelector('.pdph-cta'));
    });
  }

  // ── Modal "Jak funguje" ───────────────────────
  const modal      = document.getElementById('pdph-modal');
  const modalClose = document.getElementById('pdph-modal-close');

  function openModal() { if (modal) modal.showModal(); }

  if (modal) {
    if (modalClose) modalClose.addEventListener('click', () => modal.close());
    modal.addEventListener('click', e => { if (e.target === modal) modal.close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.open) modal.close(); });
  }

  // Delegace — zachytí kliknutí na "Jak funguje" tlačítko
  document.addEventListener('click', e => {
    if (e.target.closest('.pdph-howsub-btn')) { e.preventDefault(); openModal(); }
  });

  // Sticky add-to-cart lišta: řeší globální theme „sticky-atc-bar" (jako PP01) – vlastní odstraněna.

  // ── Hlídat dostupnost: zrcadlení Kbite tlačítka pod hlavní CTA ─────────
  // Kbite injektuje svoje tlačítko jen do theme sticky lišty. Tady ho zrcadlíme
  // do .pdph-bis pod hlavní CTA — klik na náš proxy spustí skutečné Kbite tlačítko.
  (function () {
    const anchor = wrap.querySelector('.pdph-bis');
    if (!anchor) return;
    function mirror() {
      const kbite = document.querySelector('.gw-button-widget, [gw-stock-fulfilled], .back_in_stock_button');
      if (!kbite) return false;
      if (anchor.querySelector('.pdph-notify')) return true; // už zrcadleno
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdph-notify';
      btn.textContent = (kbite.textContent || '').trim() || 'Hlídat dostupnost';
      btn.addEventListener('click', function () { kbite.click(); });
      anchor.appendChild(btn);
      return true;
    }
    if (!mirror()) {
      // Kbite injektuje asynchronně → počkáme na něj
      const mo = new MutationObserver(function () { if (mirror()) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 12000); // bezpečnostní strop
    }
  })();

  // ── Scrollspy pro taby (JEN pdp-hero) ─────────────────────────────
  // Sdílená sekce custom-product-tabs řeší klik → scroll (zůstává v originále).
  // Tady jen zvýrazňujeme aktivní tab podle pozice scrollu — pdp-hero.js běží defer
  // (DOM hotový, cílové sekce existují) a jen na pdp-hero (díky .pdph-wrap guardu výše).
  (function () {
    var tlinks = [].slice.call(document.querySelectorAll('.tabs-sticky .tab-link'));
    if (!tlinks.length) return;
    function resolveTarget(href) {
      if (!href || href[0] !== '#') return null;
      var t = null;
      try { t = document.querySelector(href); } catch (e) {}
      if (!t) {
        var key = href.replace(/^#/, '').replace(/^shopify-section-/, '');
        if (key) t = document.getElementById(key) || document.querySelector('[id$="__' + key + '"]') || document.querySelector('[id$="' + key + '"]');
      }
      return t;
    }
    function setActive(link) {
      tlinks.forEach(function (l) { l.classList.remove('active'); });
      if (link) link.classList.add('active');
    }
    // Klik → scroll robustně (JSON šablona dává sekcím id 'shopify-section-template--<id>__<klíč>',
    // takže prosté querySelector(href) ze sdíleného scriptu sekci nenajde — řešíme to tady).
    tlinks.forEach(function (l) {
      l.addEventListener('click', function (e) {
        var target = resolveTarget(l.getAttribute('href'));
        if (target) {
          e.preventDefault();
          setActive(l);
          var y = target.getBoundingClientRect().top + window.pageYOffset - 150;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });

    var tmap = tlinks.map(function (l) { return { link: l, target: resolveTarget(l.getAttribute('href')) }; }).filter(function (x) { return x.target; });
    if (!tmap.length) return;
    var LINE = 180, ticking = false;
    function spy() {
      ticking = false;
      var active = tmap[0].link;
      if (window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2) { setActive(tmap[tmap.length - 1].link); return; }
      for (var i = 0; i < tmap.length; i++) { if (tmap[i].target.getBoundingClientRect().top <= LINE) active = tmap[i].link; }
      setActive(active);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(spy); } }, { passive: true });
    spy();
  })();

  // ── Klik na libovolnou in-page kotvu #… (např. odkaz štítku na Výrobu, #vyroba, #garance…) ──
  // → plynulý scroll s offsetem, jako u tabů. Taby řeší scrollspy výše (vynecháme je).
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.classList.contains('tab-link')) return;
    var href = a.getAttribute('href');
    if (!href || href.length < 2) return;
    var target = null;
    try { target = document.querySelector(href); } catch (err) {}
    if (!target) {
      // JSON šablona dává sekcím id 'shopify-section-template--<id>__<klíč>' →
      // prostý #shopify-section-<klíč> nesedí; najdeme přes koncovku '__<klíč>'.
      var key = href.replace(/^#/, '').replace(/^shopify-section-/, '');
      if (key) target = document.getElementById(key) || document.querySelector('[id$="__' + key + '"]') || document.querySelector('[id$="' + key + '"]');
    }
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 150;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  // ── Sticky lišta (mobil): zmenši cenu, když se nevejde ──────────────
  // Theme sticky-atc-bar je do odscrollování display:none, takže měříme až
  // když se zobrazí (MutationObserver na třídu). Zmenšuje font ceny, dokud sedne.
  (function () {
    var bar = document.querySelector('.sticky-atc-bar');
    if (!bar) return;
    function fit() {
      if (window.innerWidth > 767) { return; }
      if (getComputedStyle(bar).display === 'none') return; // skrytá → neměříme
      var info = bar.querySelector('.sticky-atc-bar__product-info');
      var price = bar.querySelector('.sticky-atc-bar__product .f-price');
      if (!info || !price) return;
      info.style.fontSize = '';
      var size = parseFloat(getComputedStyle(price).fontSize) || 16;
      info.style.fontSize = size + 'px';
      var guard = 0;
      while (price.scrollWidth > info.clientWidth && size > 10 && guard < 16) {
        size -= 1; info.style.fontSize = size + 'px'; guard++;
      }
    }
    var mo = new MutationObserver(fit);
    mo.observe(bar, { attributes: true, attributeFilter: ['class'] });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fit, 200); });
    fit();
  })();

  // ── Sync ceny + slevových prvků s výběrem v Recharge widgetu ───────────
  // Při předplatném: velká cena = cena plánu, badge = sleva %, přeškrtnutá
  // původní cena + „ušetříte X". Při jednorázovém se vše vrátí do původního stavu.
  (function () {
    var priceNow = wrap.querySelector('#pdph-price-now');
    var form = wrap.querySelector('.pdph-form');
    if (!priceNow || !form || !DATA.hasSubscription) return;
    var origPrice = DATA.price;
    var plans = DATA.sellingPlans || [];
    var pct = wrap.querySelector('#pdph-price-pct');
    var nowWas = wrap.querySelector('#pdph-price-now-was');
    var discRow = wrap.querySelector('#pdph-discount-row');
    var was = wrap.querySelector('#pdph-price-was');
    var saved = wrap.querySelector('#pdph-price-saved');
    var pricePu = wrap.querySelector('#pdph-price-pu');
    var orig = {
      now: priceNow.textContent,
      pctHtml: pct ? pct.innerHTML : null, pctDisp: pct ? pct.style.display : null,
      nowWasDisp: nowWas ? nowWas.style.display : null,
      discDisp: discRow ? discRow.style.display : null,
      was: was ? was.textContent : null, saved: saved ? saved.textContent : null
    };
    // Karty balení (90 tob., 3×90…) – ulož si původní cenu/tob. pro návrat
    var packCards = wrap.querySelectorAll('.pdph-pack-card');
    packCards.forEach(function (card) { var sup = card.querySelector('.pdph-sup'); if (sup) card.setAttribute('data-pu-orig', sup.textContent); });
    function perUnitStr(cents) { return perUnit(cents, DATA.capsuleCount || 0, DATA.unitSuffix); }
    function activePlan() {
      var inputs = form.querySelectorAll('[name="selling_plan"]');
      for (var i = 0; i < inputs.length; i++) { if (!inputs[i].disabled && inputs[i].value) return inputs[i].value; }
      return '';
    }
    function priceFor(id) {
      var p = null;
      for (var i = 0; i < plans.length; i++) { if (String(plans[i].id) === String(id)) { p = plans[i]; break; } }
      if (!p) return (DATA.subscriptionPrice > 0) ? DATA.subscriptionPrice : origPrice;
      if (p.discountType === 'percentage') return Math.round(origPrice * (100 - p.discountValue) / 100);
      if (p.discountType === 'fixed_amount') return Math.max(0, origPrice - p.discountValue);
      if (p.discountType === 'price') return p.discountValue;
      return origPrice;
    }
    // V tomto theme je v sticky liště jen blok .f-price__sale (regular je
    // zakomentovaný), takže f-price--on-sale musí zůstat, jinak se nezobrazí nic.
    //   .f-price-item--sale    = aktuální cena (vždy)
    //   .f-price-item--regular = přeškrtnutá původní – jen když je sleva
    function setStickyPrice(cents, wasCents) {
      var bar = document.querySelector('.sticky-atc-bar');
      if (!bar) return;
      var hasDiscount = wasCents && wasCents > cents;
      bar.querySelectorAll('.f-price').forEach(function (fp) {
        fp.classList.add('f-price--on-sale');
        var sale = fp.querySelector('.f-price-item--sale');
        if (sale) sale.textContent = fmt(cents);
        var reg = fp.querySelector('.f-price-item--regular');
        if (reg) {
          if (hasDiscount) { reg.innerHTML = '<s>' + fmt(wasCents) + '</s>'; reg.style.display = ''; }
          else { reg.textContent = ''; reg.style.display = 'none'; }
        }
      });
    }
    function showSub(sub) {
      priceNow.textContent = fmt(sub);
      var p = Math.round((origPrice - sub) / origPrice * 100);
      if (pct) { pct.innerHTML = '-' + p + '&nbsp;%'; pct.style.display = ''; }
      if (nowWas) nowWas.style.display = 'none';
      if (discRow) discRow.style.display = 'flex';
      if (was) was.textContent = fmt(origPrice);
      if (saved) saved.textContent = 'ušetříte ' + fmt(origPrice - sub);
    }
    function restore() {
      priceNow.textContent = orig.now;
      if (pct) { pct.innerHTML = orig.pctHtml; pct.style.display = orig.pctDisp; }
      if (nowWas) nowWas.style.display = orig.nowWasDisp;
      if (discRow) discRow.style.display = orig.discDisp;
      if (was) was.textContent = orig.was;
      if (saved) saved.textContent = orig.saved;
    }
    // Per-unit (cena za tob./dávku) drž vždy podle aktuální frekvence – re-assert
    // každý tick, aby to nepřepsal updatePrice() zpět na jednorázovou hodnotu.
    function syncPerUnit(sp) {
      if (!pricePu) return;
      var pu = perUnitStr(sp ? priceFor(sp) : origPrice);
      if (pu) pricePu.textContent = pu;
    }
    // Cena za tobolku na kartách balení (90 tob., 3×90…) – u předplatného zlevni
    // stejným poměrem jako hlavní cenu, u jednorázového vrať původní.
    function syncPackUnits(sp) {
      if (!packCards.length) return;
      var ratio = (sp && origPrice > 0) ? (priceFor(sp) / origPrice) : 1;
      packCards.forEach(function (card) {
        var sup = card.querySelector('.pdph-sup');
        if (!sup) return;
        if (!sp) { var o = card.getAttribute('data-pu-orig'); if (o != null) sup.textContent = o; return; }
        var price = parseInt(card.getAttribute('data-price'), 10);
        var caps = parseInt(card.getAttribute('data-caps'), 10);
        if (!price || !caps) return;
        var pu = perUnit(Math.round(price * ratio), caps, DATA.unitSuffix);
        if (pu) sup.textContent = pu;
      });
    }
    var last;
    function sync() {
      var sp = activePlan();
      var target = sp ? priceFor(sp) : origPrice;
      // přeškrtnutá cena: u předplatného = plná cena; u jednorázového = compare-at (pokud je)
      var wasVal = sp ? origPrice : (DATA.compareAtPrice > origPrice ? DATA.compareAtPrice : 0);
      setStickyPrice(target, wasVal);
      syncPerUnit(sp);
      syncPackUnits(sp);
      if (sp === last) return;
      last = sp;
      if (sp) showSub(target); else restore();
    }
    sync();
    setInterval(sync, 400);
    document.addEventListener('click', function () { setTimeout(sync, 60); }, true);
    window.addEventListener('load', sync);
  })();

  // ── Init ─────────────────────────────────────
  updatePrice();

})();
